import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { LocationSetsActions, AsyncActions } from './location-sets.actions';
import { LocationSetTypesActions } from '../location-set-types/location-set-types.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import {LocationSet} from '@emm/core/models/location-set.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {locationSetsSort} from '@emm/core/util/sort.util';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const locationSetsFeatureKey = 'locationSets';

export interface LocationSetsState extends EntityState<LocationSet>, AsyncActionState {
    filter: string;
    selectedTag: string | null;
    childLocationSets: LocationSet[];
}

export const adapter: EntityAdapter<LocationSet> = createEntityAdapter<LocationSet>({
    selectId: (item: LocationSet) => item.tag,
    sortComparer: locationSetsSort,
});

export const initialState: LocationSetsState = adapter.getInitialState({
    selectedTag: null,
    filter: null,
    childLocationSets: [],
    ...asyncActionState.initial,
});

export const locationSetsReducer = withLoadables<LocationSetsState>({
    loadActions: LocationSetsActions.loadAllByScope,
    successActions: LocationSetsActions.loadAllByScopeSuccess,
    errorActions: LocationSetsActions.loadAllByScopeFailure,
    ...AsyncActions
})(
    initialState,

    on(ManagementBaseActions.initItemGroupings, () => ({
        ...initialState
    })),

    on(LocationSetsActions.deleteLocationSetSuccess, (state: LocationSetsState) => ({
        ...state,
        selectedTag: null
    })),
    on(LocationSetsActions.loadAllByScopeSuccess, LocationSetsActions.loadChildLocationsSuccess,
        (state: LocationSetsState, { locationSets }) =>
        adapter.setAll(locationSets, state)
    ),

    on(
        LocationSetTypesActions.select,
        LocationSetTypesActions.load,
        LocationSetsActions.loadAllByScope,
        (state: LocationSetsState) => ({
            ...state,
            selectedTag: null
        })
    ),

    on(
        LocationSetTypesActions.select,
        (state: LocationSetsState) => ({
            ...state,
            selectedTag: null,
            ...asyncActionState.initial
        })
    ),

    on(LocationSetsActions.select, (state: LocationSetsState, { tag }) => ({
        ...state,
        selectedTag: tag
    })),

    on(LocationSetsActions.updateFilter, (state: LocationSetsState, { filter }) => ({
        ...state,
        filter
    }))

);
